import React, { JSX } from "react";
import { Form } from "react-bootstrap";
import { UseFormReturn, WatchObserver } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormCheck, FormInput } from "go-form";
import { FormSelectGroup } from "go-form/components/FormSelect";
import {
	PrintoutTemplateApi,
	PrintoutTemplateFontSizeType,
} from "../../../../../../../../../services/Api/Organization/types";
import { getPrintoutTemplateFontOptions } from "../utils";

interface Props {
	form: UseFormReturn<PrintoutTemplateApi>;
	name: string;
	label: string | JSX.Element;
	withoutAdditionalOptions?: boolean;
	alwaysPrint?: boolean;
}

const PrintoutTemplateVisibilityOptionForm = ({ form, name, label, withoutAdditionalOptions, alwaysPrint }: Props) => {
	const {
		formState: { errors },
		register,
		control,
		watch,
	} = form;
	const { t } = useTranslation();
	const finalNameTextSize = watch(`${name}_text_size` as unknown as WatchObserver<PrintoutTemplateApi>);
	const isChecked = watch(name as unknown as WatchObserver<PrintoutTemplateApi>);

	return (
		<div className="printout-template-visibility-option-form">
			<div className="print-option-container">
				{alwaysPrint ? (
					<>
						<Form.Label style={{ fontSize: "14px" }}>{label}</Form.Label>
						<FormInput type="hidden" name={name} errors={errors} register={register} value={name} />
					</>
				) : (
					<FormCheck type="switch" label={label} name={name} errors={errors} register={register} />
				)}
			</div>
			{!withoutAdditionalOptions && isChecked && (
				<div className="options-container">
					<FormCheck
						type="switch"
						label={t("modules.printout_template.field.bold.title")}
						name={`${name}_bold`}
						errors={errors}
						register={register}
						disabled={!isChecked}
					/>
					<div className="vr" />
					<div className="d-flex align-items-center gap-2 flex-grow-1 font-size-select">
						<Form.Label style={{ fontSize: "14px" }}>
							{t("modules.printout_template.field.font_size.title")}
						</Form.Label>
						<FormSelectGroup
							errors={errors}
							control={control}
							name={`${name}_text_size`}
							options={getPrintoutTemplateFontOptions(t, [PrintoutTemplateFontSizeType.DELIVERY])}
							data-testid={`${name}_text_size`}
							disabled={!isChecked}
							defaultValue={{
								value: finalNameTextSize,
								label: finalNameTextSize ? t(`enums.printout.font.${finalNameTextSize}`) : "",
							}}
						/>
					</div>
				</div>
			)}
		</div>
	);
};

export default PrintoutTemplateVisibilityOptionForm;
